var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 78,
    viewBox: "0 0 37 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9362 21.6441L18.569 9.81619C3.42059 29.6444 2.87706 41.2004 20.3672 66.0184L24.0671 63.8382C17.5253 49.3874 14.4369 36.7675 35.3835 16.4175C34.9831 16.4898 20.9398 21.6399 20.9398 21.6399L20.9362 21.6441Z",
    fill: "#C6B4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6275 62.3914L0.30481 56.1423L26.4966 76.5043L29.0745 52.0578L20.6275 62.3914Z",
    fill: "#A678F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_687"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.1763,
    height: 76.9708,
    fill: "white",
    transform: "translate(0.294678 0.229004)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowMobile);
export default __webpack_public_path__ + "static/media/arrow-Mobile.c5a492c6517f8581736c1bb035f59dca.svg";
export { ForwardRef as ReactComponent };